angular.module('rjmNg.services').factory 'dataPerspective', [
  "timeRangeEnums"
  "rjqlStringConstants"
  (
    timeRangeEnums,
    rjqlStringConstants
  ) ->

    _getMeasureField = (source, isSingleSource) ->
      if not isSingleSource then [source.alias, ":value"] else ":value"

    _getPerspectiveMeasure_0_1 = (source, isSingleSource, timeInterval) ->
      field = _getMeasureField(source, isSingleSource)
      time = if not isSingleSource then [source.alias, rjqlStringConstants.RJQL_TIME] else rjqlStringConstants.RJQL_TIME
      measure =
        field: field
        time: time
        label: source.alias
        type: 'function'

      switch source.perspective
        when 'standard'
          measure = field

        when 'cumulative'
          measure.function = 'sum'
          measure.offset = ':time-range-start'

        when 'amountVsPreviousPeriod'
          measure.function = 'diff'
          measure.offset =
            type: 'point-relative'
            unit: ':time-interval'

        when 'amountVsPreviousYear'
          measure.function = 'diff'
          measure.offset =
            type: 'point-relative'
            value: -1
            unit: 'year'

        when 'percentVsPreviousPeriod'
          measure.function = 'diffpercent'
          measure.offset =
            type: 'point-relative'
            unit: ':time-interval'

        when 'percentVsPreviousYear'
          measure.function = 'diffpercent'
          measure.offset =
            type: 'point-relative'
            value: -1
            unit: 'year'

        when 'percentOfFirstValueShowFirstValue'
          measure.function = 'diffpercent'
          measure.offset = ":time-range-start"

        when 'percentOfFirstValueHideFirstValue'
          measure.function = 'diffpercent'
          measure.offset = ":time-range-start-hide-first"

      return measure

    _getPerspectiveMeasure_1_0 = (source, isSingleSource, timeInterval, rows) ->
      field = _getMeasureField(source, isSingleSource)
      measureByTime = getTimeKeyword(isSingleSource)
      measureBy = getTimeKeyword(isSingleSource)
      unit = ':interval'

      if timeInterval is timeRangeEnums.TIME_INTERVAL_VALUES.NONE or
        source.timeUnbound is true
          unit = ':range'
          if rows?
            if isSingleSource
              measureBy = source.dimensions[0].column_id
            else
              measureBy = rows[0].name

      measure =
        field: field
        label: source.alias
        type: 'function'

      switch source.perspective
        when 'standard'
          measure = field

        when 'cumulative'
          measure.function = 'rolling-aggregate'
          measure.op = 'sum'
          measure.by = measureBy
          measure.offset =
            relative_to: 'start'

        when 'cumulativeCohort'
          measure.function = 'rolling-aggregate'
          measure.op = 'sum'
          measure.by = rjqlStringConstants.RJQL_PERIODDIFF
          measure.offset =
            relative_to: 'start'

        when 'amountVsPreviousPeriod'
          measure.function = 'offset-diff'
          measure.op = null
          measure.by = measureByTime
          measure.offset =
            relative_to: 'point'
            value: -1
            # :range if not over time
            unit: unit

        when 'amountVsPreviousYear'
          measure.function = 'offset-diff'
          measure.op = null
          measure.by = measureByTime
          measure.offset =
            relative_to: 'point'
            value: -1
            unit: 'Year'

        when 'percentVsPreviousPeriod'
          measure.function = 'offset-diff-percent'
          measure.op = null
          measure.by = measureByTime
          measure.offset =
            relative_to: 'point'
            value: -1
            unit: unit

        when 'percentVsPreviousYear'
          measure.function = 'offset-diff-percent'
          measure.op = null
          measure.by = measureByTime
          measure.offset =
            relative_to: 'point'
            value: -1
            unit: 'Year'

        when 'percentOfFirstValueShowFirstValue'
          measure.function = 'offset-percent'
          measure.op = null
          measure.by = measureBy
          measure.offset =
            relative_to: 'start'

        when 'percentOfFirstValueShowFirstValueCohort'
          measure.function = 'offset-percent'
          measure.op = null
          measure.by = rjqlStringConstants.RJQL_PERIODDIFF
          measure.offset =
            relative_to: 'start'

        when 'percentOfFirstValueHideFirstValueCohort'
          measure.function = 'offset-percent'
          measure.op = null
          measure.by = rjqlStringConstants.RJQL_PERIODDIFF
          measure.offset =
            relative_to: 'start'
            value: -1
            unit: timeInterval

        when 'cumulativeAverageValuePerCohortMember'
          measure.function = 'rolling-aggregate'
          measure.op = 'cumulative-average-cohort'
          measure["counting-members"] = source["counting-members"]
          measure.by = rjqlStringConstants.RJQL_PERIODDIFF
          measure.offset =
            relative_to: 'start'
            value: 1
            unit: timeInterval

        when 'averageValuePerCohortMember'
          measure.function = 'rolling-aggregate'
          measure.op = 'average-cohort'
          measure["counting-members"] = source["counting-members"]
          measure.by = rjqlStringConstants.RJQL_PERIODDIFF
          measure.offset =
            relative_to: 'start'
            value: 1
            unit: timeInterval

        when 'rollingAverage'
          measure.function = 'rolling-aggregate'
          measure.op = 'average'
          measure.by = measureBy
          measure.offset =
            relative_to: 'point'
            value: -source.averageWindowLength
            unit: timeInterval

      return measure

    getTimeKeyword = (isSingleSource) ->
      if isSingleSource then rjqlStringConstants.RJQL_TIME else "time"

    getPerspectiveMeasure = (source, isSingleSource, timeInterval, version, rows=null) ->
      unless source.perspective?
        throw 'No perspective is defined on the source, unable to proceed.'
      switch version
        when 0.1 then _getPerspectiveMeasure_0_1(source, isSingleSource, timeInterval)
        when 1.0 then _getPerspectiveMeasure_1_0(source, isSingleSource, timeInterval, rows)

    {
      getTimeKeyword
      getPerspectiveMeasure
    }
  ]